/* eslint-disable camelcase */
/* eslint-disable indent */
import { getLocalStorage, setLocalStorage } from '@/utils/cookies';
import { ArrowRightOutlined, RedoOutlined } from '@ant-design/icons';
import { Spin } from '@sinohealth/butterfly-ui-components';
import { Ref, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { httpGetCaptcha, httpVerifyCaptcha } from '../../http';
import { aesEncrypt } from '../../utils/ase';
import styles from './index.less';

type CaptchaProps = {
  captchaSuccess?: (token: string) => void;
  captchaError?: () => void;
};

/** 滑块验证 */
const Captcha = (props: CaptchaProps, ref: Ref<unknown> | undefined) => {
  const [secretKey, setSecretKey] = useState(''); // 后端返回的ase加密秘钥
  const [checkNum, setCheckNum] = useState(3); // 默认需要点击的字数
  const [imgSize] = useState({
    imgHeight: 155,
    imgWidth: 310,
    barHeight: 40,
    barWidth: 310,
  });
  const [backImgBase, setBackImgBase] = useState(''); // 后端获取到的背景图片
  const [backToken, setBackToken] = useState(''); // 后端返回的token值
  const [captchaType] = useState('blockPuzzle');
  const [passFlag, setPassFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tipWords, setTipWords] = useState('');
  const [leftBarWidth, setLeftBarWidth] = useState(0);
  const [leftBarBorderColor, setLeftBarBorderColor] = useState('');
  const [loadingText, setLoadingText] = useState('');
  const [moveBlockLeft, setMoveBlockLeft] = useState(-1);
  const [moveBlockBackgroundColor, setMoveBlockBackgroundColor] = useState('');
  const [blockBackImgBase, setBlockBackImgBase] = useState(''); // 验证滑块的背景图片
  const [startLeft, setStartLeft] = useState(0);
  const [blockSize, setBlockSize] = useState({
    width: '50',
    height: '50',
  });
  const [barAreaLeft, setBarAreaLeft] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  const [transitionLeft, setTransitionLeft] = useState('');
  const [transitionWidth, setTransitionWidth] = useState('');
  const [barAreaOffsetWidth, setBarAreaOffsetWidth] = useState(0);
  const [status, setStatus] = useState(false);
  const [startMoveTime, setStartMoveTime] = useState(0);
  const [endMovetime, setEndMovetime] = useState(0);
  const [bindingClick, setBindingClick] = useState(false);
  const captchaContainer = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      refreshFn() {
        refresh();
      },
    };
  });

  // 初始化数据
  const getData = () => {
    setLoadingText('数据获取中');
    setIsLoading(true);
    httpGetCaptcha({
      captchaType,
      clientUid: localStorage.getItem('point'),
      ts: Date.now(),
    })
      .then((res: any) => {
        setBackImgBase(res.originalImageBase64);
        setBlockBackImgBase(res.jigsawImageBase64);
        setBackToken(res.token);
        setSecretKey(res.secretKey);
        setCheckNum(res.wordList.length);
        setBindingClick(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const refresh = () => {
    setTransitionLeft('left .3s');
    setMoveBlockLeft(-1);

    setLeftBarWidth(0);
    setTransitionWidth('width .3s');

    setLeftBarBorderColor('#ddd');
    setMoveBlockBackgroundColor('#fff');
    setIsEnd(false);
    props.captchaError && props.captchaError();
    getData();
    const t = setTimeout(() => {
      setTransitionWidth('');
      setTipWords('');
      setTransitionLeft('');
      clearTimeout(t);
    }, 300);
  };

  const start = (event: any) => {
    console.log('start------');
    const e = event || window.event;
    let x = 0;
    if (!e.touches) {
      // 兼容PC端
      x = e.clientX;
    } else {
      // 兼容移动端
      x = e.touches[0].pageX;
    }
    setStartLeft(Math.floor(x - barAreaLeft));
    setStartMoveTime(+new Date()); // 开始滑动的时间
    if (isEnd === false) {
      console.log({ isEnd });
      setStatus(true);
      setLeftBarBorderColor('#337AB7');
      setMoveBlockBackgroundColor('#337ab7');
      e.stopPropagation();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const move = (event: any) => {
      console.log('move');
      const e = event || window.event;
      if (status && isEnd === false) {
        let x = 0;
        if (!e.touches) {
          // 兼容PC端
          x = e.clientX;
        } else {
          // 兼容移动端
          x = e.touches[0].pageX;
        }
        const barareaLeft = barAreaLeft;
        let move_block_left = x - barareaLeft; // 小方块相对于父元素的left值
        if (
          move_block_left >=
          barAreaOffsetWidth - parseInt((parseInt(blockSize.width, 10) / 2).toString(), 10) - 2
        ) {
          move_block_left =
            barAreaOffsetWidth - parseInt((parseInt(blockSize.width, 10) / 2).toString(), 10) - 2;
        }
        if (move_block_left <= 0) {
          move_block_left = parseInt((Number(blockSize.width) / 2).toString(), 10);
        }
        // console.log(move_block_left);
        // 拖动后小方块的left值
        // console.log(x - startLeft);
        if (x === 0) return;
        const moveX = x - startLeft;
        // setMoveBlockLeft(moveX);
        // setLeftBarWidth(moveX);
        if (moveX <= 0) {
          setMoveBlockLeft(-1);
          setLeftBarWidth(0);
          setLocalStorage('sta', 0);
        } else if (moveX >= 265) {
          setMoveBlockLeft(265);
          setLeftBarWidth(265);
          setLocalStorage('sta', 265);
        } else {
          setMoveBlockLeft(x - startLeft <= 0 ? -1 : x - startLeft);
          setLeftBarWidth(x - startLeft <= 0 ? 0 : x - startLeft);
          setLocalStorage('sta', x - startLeft <= 0 ? 0 : x - startLeft);
        }
      }
    };
    const end = () => {
      console.log('end------');
      setEndMovetime(+new Date());
      // console.log(moveBlockLeft);
      // 判断是否重合
      if (status && isEnd === false) {
        const x = getLocalStorage('sta');
        let moveLeftDistance = parseInt((x || '').toString().replace('px', ''), 10);
        moveLeftDistance = (moveLeftDistance * 310) / parseInt(imgSize.imgWidth.toString(), 10);
        const data = {
          captchaType,
          pointJson: secretKey
            ? aesEncrypt(JSON.stringify({ x: moveLeftDistance, y: 5.0 }), secretKey)
            : JSON.stringify({ x: moveLeftDistance, y: 5.0 }),
          token: backToken,
          clientUid: localStorage.getItem('slider'),
          ts: Date.now(),
        };
        setIsLoading(true);
        setLoadingText('数据校验中, 请稍候');
        httpVerifyCaptcha(data)
          .then(() => {
            setIsEnd(true);
            setPassFlag(true);
            setTipWords(`${((+new Date() - startMoveTime) / 1000).toFixed(2)}s验证成功`);
            const captchaVerification = secretKey
              ? aesEncrypt(
                  `${backToken}---${JSON.stringify({
                    x: moveLeftDistance,
                    y: 5.0,
                  })}`,
                  secretKey,
                )
              : `${backToken}---${JSON.stringify({
                  x: moveLeftDistance,
                  y: 5.0,
                })}`;

            props.captchaSuccess && props.captchaSuccess(captchaVerification);
            // setTipWords('');
            // refresh();
          })
          .catch(() => {
            setIsEnd(true);
            setPassFlag(false);
            setTipWords('验证失败');
            const t = setTimeout(() => {
              setTipWords('');
              refresh();
              clearTimeout(t);
            }, 1000);
          })
          .finally(() => {
            setIsLoading(false);
          });
        setStatus(false);
      }
    };
    if (status) {
      document.addEventListener('touchmove', move);
      document.addEventListener('mousemove', move);
      document.addEventListener('touchend', end);
      document.addEventListener('mouseup', end);
    }
    return () => {
      document.removeEventListener('touchmove', move);
      document.removeEventListener('mousemove', move);
      document.removeEventListener('touchend', end);
      document.removeEventListener('mouseup', end);
    };
  }, [status, moveBlockLeft, setMoveBlockLeft, setLeftBarWidth]);

  return (
    <Spin spinning={isLoading} tip={loadingText}>
      <div className={styles['captcha-container']}>
        <div
          className={styles.captcha}
          style={{ backgroundImage: `url(data:image/png;base64,${backImgBase})` }}
        >
          <RedoOutlined
            style={{ color: '#FFF' }}
            className={styles['verifybox-close']}
            onClick={() => refresh()}
          />
          <div
            className={styles['captcha-move']}
            style={{
              left: `${moveBlockLeft}px`,
              transition: transitionLeft,
            }}
          >
            <img src={`data:image/png;base64,${blockBackImgBase}`} alt="" />
          </div>
          <CSSTransition
            in={tipWords.length > 0}
            timeout={0}
            classNames={styles.tips}
            unmountOnExit
          >
            <span
              className={
                passFlag
                  ? `${styles['verify-tips']} ${styles['suc-bg']}`
                  : `${styles['verify-tips']} ${styles['err-bg']}`
              }
            >
              {tipWords}
            </span>
          </CSSTransition>
        </div>
        <div className={styles['captcha-side']}>
          <div
            className={styles['side-btn']}
            onTouchStart={(e) => start(e)}
            onMouseDown={(e) => start(e)}
            style={{
              left: `${moveBlockLeft}px`,
              transition: transitionLeft,
            }}
          >
            <ArrowRightOutlined className={styles['side-icon']} />
          </div>
        </div>
      </div>
    </Spin>
  );
};

const CaptchaRef = forwardRef(Captcha);

export default CaptchaRef;
